"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

import { usePulse } from "../../pulse/usePulse";
import { isArticlePage } from "../../utils/page";

const PulseLeaveArticlePage = () => {
  const pathName = usePathname();
  const [_, setPreviousPage] = useState("");
  const { trackPageLeave } = usePulse();
  const runOnce = useRef(true);

  useEffect(() => {
    setPreviousPage((previousPage) => {
      if (
        isArticlePage(previousPage) &&
        pathName !== previousPage &&
        runOnce.current
      ) {
        trackPageLeave();
        runOnce.current = false;
      }

      setPreviousPage(pathName);

      return pathName;
    });

    return () => {
      runOnce.current = true;
    };
  }, [pathName, trackPageLeave]);

  return null;
};

export { PulseLeaveArticlePage };
